import '../scss/frontend.css';

window.isMobile = false;

import './sources/index';
